import {SELECT_VIEW} from '../components/page/settings/constants';
import {selectViewFunction} from '../moduls/utils';

const getStepStructure = function (step) {
  const StepStructure = selectViewFunction(step, SELECT_VIEW);
  return StepStructure.backDataToModel(step);
}

export default class Widget {
  constructor(data) {
    this.id = ('id' in data) ? data.id : 0;
    this.type = ('type' in data) ? data.type : 'poll';
    this.title = ('title' in data) ? data.title : null;
    this.description = ('description' in data) ? data.description : null;
    this.steps = ('steps' in data) ? new Map(Object.entries(data.steps).map((item) => [item[0], getStepStructure(item[1])])) : {};
    this._start = ('start' in data) ? data.start : null;
  }

  get start() {
    return this._start;
  }
};




// WEBPACK FOOTER //
// ./model/widget.js